import { Directive, ElementRef, forwardRef, HostListener, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appPhoneFormat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneFormatDirective),
      multi: true,
    },
  ],
})
export class PhoneFormatDirective {
  public phoneNumber = '';

  private onChange: (value: string) => void = () => {
    return;
  };
  private onTouched: () => void = () => {
    return;
  };
  private elementRef = inject(ElementRef<HTMLInputElement>);

  public writeValue(value: string): void {
    const sanitizedValue = this.removeFirstDigit(value);
    const formattedUiValue = this.formatForUi(sanitizedValue);

    this.elementRef.nativeElement.value = formattedUiValue;
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event.target.value'])
  public onInput(value: string): void {
    const uiValue = this.formatForUi(value);
    const rawValue = this.formatForValue(value);
    this.onChange(rawValue);
    this.elementRef.nativeElement.value = uiValue;
  }

  @HostListener('blur')
  public onBlur(): void {
    this.onTouched();
  }

  private formatForUi(value: string): string {
    if (!value) {
      return '';
    }

    const cleanedValue = this.sanitizeInput(value);
    const formattedValue = cleanedValue.replace(/^(\d{3})(\d{3})(\d{0,4}).*/, (_match, p1, p2, p3) =>
      [p1, p2, p3].filter(Boolean).join('-')
    );
    return cleanedValue.length > 0 ? `${formattedValue}` : '';
  }

  private formatForValue(value: string): string {
    const sanitized = this.sanitizeInput(value);
    return `1${sanitized}`;
  }

  private sanitizeInput(value: string): string {
    return value.replace(/[^\d]/g, '').slice(0, 10);
  }

  private removeFirstDigit(value: string): string {
    return value?.replace(/[^\d]/g, '').slice(1);
  }
}
